import { combineReducers } from "redux";
import authReducer from "./authReducer";
import modalReducer from "./modalReducer";
import chatbotReducer from "./chatbotReducer";
import notificationReducer from "./notificationModalReducer";
import KBUtilityReducer from "./kbUtilityReducer";
import GlobalDataReducer from "./globalDataReducer";
import LogsReviewDataReducer from "./logsReviewDataReducer";
import taskpdfReducer from "./taskpdfReducer";
import { RESET_APP_STORAGE } from "../../common/actionTypes";
import productFeedbackReducer from "./productFeedbackReducer";
import taskscribeReducer from './taskscribeReducer';
import PromptAiReducer from './promptAiReducer';

const appReducer = combineReducers({
  auth: authReducer,
  modal: modalReducer,
  chatbot: chatbotReducer,
  notification: notificationReducer,
  kbUtility: KBUtilityReducer,
  globalData: GlobalDataReducer,
  logsReviewData: LogsReviewDataReducer,
  taskPDF: taskpdfReducer,
  productFeedbackData: productFeedbackReducer,
  taskscribe:taskscribeReducer,
  promptAiData: PromptAiReducer,
});

const rootReducer = (state, action) => {
  if (action.type === RESET_APP_STORAGE) {
    // reset state
    state = undefined;
    // reset local storage
    localStorage.clear();
  }
  return appReducer(state, action);
};
export default rootReducer;
